<template>
  <div>
    <AppLayout title="Serviços">
      <template #actions>
        <button type="button" @click="show_newService()" class="btn btn-primary">Novo Serviço</button>
      </template>

      <table class="table" v-if="lista_servicos.length">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Preço</th>
            <th>Duração</th>
            <th>Ativo</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="servico in lista_servicos" :key="servico.id">
            <td>{{ servico.name }}</td>
            <td>{{ formatter.currency(servico.price) }}</td>
            <td>{{ servico.duration_minutes ? servico.duration_minutes + ' min' : '—' }}</td>
            <td>
              <span class="badge" :class="servico.active ? 'text-bg-success' : 'text-bg-secondary'">
                {{ servico.active ? 'Ativo' : 'Inativo' }}
              </span>
            </td>
            <td style="width:50px"><button @click="show_editService(servico)" type="button" class="btn btn-primary btn-sm"><i class="bi bi-pencil-square"></i></button></td>
            <td style="width:50px"><button @click="show_deleteService(servico)" type="button" class="btn btn-danger btn-sm"><i class="bi bi-trash-fill"></i></button></td>
          </tr>
        </tbody>
      </table>
      <p v-else class="text-muted">Nenhum serviço cadastrado ainda.</p>
    </AppLayout>

    <!-- Modal Serviço -->
    <div class="modal fade" id="modal_servico" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ edit ? 'Editar Serviço' : 'Novo Serviço' }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form id="form-servico">
              <div class="mb-3">
                <label for="inp_name" class="form-label">Nome:</label>
                <input v-model="servico.name" type="text" class="form-control" id="inp_name">
              </div>
              <div class="mb-3">
                <label for="inp_description" class="form-label">Descrição:</label>
                <textarea v-model="servico.description" class="form-control" id="inp_description" rows="2"></textarea>
              </div>
              <div class="row">
                <div class="mb-3 col">
                  <label for="inp_price" class="form-label">Preço:</label>
                  <input v-model="servico.price" type="number" step="0.01" min="0" class="form-control" id="inp_price">
                </div>
                <div class="mb-3 col">
                  <label for="inp_duration" class="form-label">Duração (minutos):</label>
                  <input v-model="servico.duration_minutes" type="number" min="1" class="form-control" id="inp_duration" placeholder="ex.: 60">
                </div>
              </div>
              <div class="form-check">
                <input v-model="servico.active" class="form-check-input" type="checkbox" id="inp_active">
                <label class="form-check-label" for="inp_active">Ativo (aparece no PDV)</label>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
            <button type="submit" @click="actionService()" class="btn btn-primary">Salvar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Deletar -->
    <div class="modal fade" id="modal_deletar" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Excluir serviço?</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body"><p>{{ servico.name }}</p></div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
            <button @click="deleteService()" class="btn btn-danger">Excluir</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Feedback -->
    <div class="modal fade" id="modal_feedback" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ feedback_error ? 'Erro' : 'Sucesso' }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body"><p>{{ msn_feedback }}</p></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive, ref } from 'vue';
import { Modal } from "bootstrap";
import AppLayout from "@/components/AppLayout.vue";
import { servicos } from "@/models/servicos";
import formatter from "@/services/formaterService";

export default {
  name: 'ServicesView',
  components: { AppLayout },
  setup() {
    const lista_servicos = ref([]);
    const Servicos = servicos();

    const edit = ref(false);
    const msn_feedback = ref('');
    const feedback_error = ref(false);
    let modal = '';

    const servico = reactive({
      id: '', name: '', description: '', price: '', duration_minutes: '', active: true,
    });

    function openModal(elemento) {
      modal = new Modal(document.getElementById(elemento));
      modal.show();
    }

    function closeModal() {
      modal?.hide();
    }

    function limparDados() {
      servico.id = '';
      servico.name = '';
      servico.description = '';
      servico.price = '';
      servico.duration_minutes = '';
      servico.active = true;
    }

    const show_newService = () => {
      limparDados();
      edit.value = false;
      openModal('modal_servico');
    };

    const show_editService = (item) => {
      edit.value = true;
      servico.id = item.id;
      servico.name = item.name;
      servico.description = item.description;
      servico.price = item.price;
      servico.duration_minutes = item.duration_minutes;
      servico.active = item.active;
      openModal('modal_servico');
    };

    const show_deleteService = (item) => {
      servico.id = item.id;
      servico.name = item.name;
      openModal('modal_deletar');
    };

    const listServices = async () => {
      lista_servicos.value = await Servicos.list() ?? [];
    };

    const saveService = async () => {
      const resultado = await Servicos.createItem(servico);
      if (resultado === true) {
        closeModal();
        feedback_error.value = false;
        msn_feedback.value = 'Serviço cadastrado com sucesso!';
        openModal('modal_feedback');
        listServices();
      } else {
        feedback_error.value = true;
        msn_feedback.value = typeof resultado === 'string' ? resultado : 'Erro ao cadastrar serviço.';
        openModal('modal_feedback');
      }
    };

    const updateService = async () => {
      if (await Servicos.updateItem(servico)) {
        closeModal();
        feedback_error.value = false;
        msn_feedback.value = 'Serviço atualizado com sucesso!';
        openModal('modal_feedback');
        listServices();
      }
    };

    const actionService = () => {
      edit.value ? updateService() : saveService();
    };

    const deleteService = async () => {
      if (await Servicos.deleteItem(servico.id)) {
        closeModal();
        feedback_error.value = false;
        msn_feedback.value = 'Serviço excluído com sucesso!';
        openModal('modal_feedback');
        listServices();
      }
    };

    onMounted(() => {
      listServices();
    });

    return {
      lista_servicos, servico, edit, msn_feedback, feedback_error, formatter,
      show_newService, show_editService, show_deleteService, actionService, deleteService,
    };
  },
}
</script>
